// extracted by mini-css-extract-plugin
export default {"root":"styles_root__xs69n","body":"styles_body__Ai8BA"};